<jqxDropDownButton #myDropDownButton [width]="330" [height]="25">
    Place the grid here if we need a dropdown
</jqxDropDownButton>

<jqxTreeGrid [width]="width" [disabled]="disabled" [source]="dataAdapter" [sortable]="true" [columns]="columns"
    (onRowCheck)="rowCheck($event)" (onRowUncheck)="rowUncheck($event)" [ready]="ready" [height]="400"
    [filterable]="true" [showHeader]="false" [checkboxes]="true" [columnsResize]="true" [hierarchicalCheckboxes]="true"
    #myTree>
</jqxTreeGrid>